import { ChangeDetectionStrategy, Component, input, output, signal, viewChild } from '@angular/core';
import { ModalRef } from '@siemens/element-ng/modal';
import { File } from '@tran-monorepo/interfaces/files';
import { ConfirmModalResultEnum } from '../../../enums/confirm-modal.enum';
import { BaseFileItemComponent } from '../base-file-item/base-file-item.component';
import { FileDeleteModalComponent } from '../file-delete-modal/file-delete-modal.component';

@Component({
    selector: 'tran-file-item',
    imports: [FileDeleteModalComponent, BaseFileItemComponent],
    templateUrl: './file-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileItemComponent {
    public readonly attachment = input.required<File>();
    public readonly allowDownload = input<boolean>(false);
    public readonly allowDelete = input<boolean>(false);
    public readonly askDelete = input<boolean>(true);
    public readonly allowUndoDelete = input<boolean>(false);
    public readonly download = output<File>();
    public readonly delete = output<File>();
    public readonly undoDelete = output<File>();

    private readonly deleteFileModal = viewChild.required<FileDeleteModalComponent>('deleteFileModal');
    public deleteFileModalRef?: ModalRef;

    protected readonly isDeleted = signal<boolean>(false);
    protected readonly ConfirmModalResultEnum = ConfirmModalResultEnum;

    protected onDeleteFile(): void {
        if (this.allowDelete() && !this.isDeleted()) {
            if (this.askDelete()) {
                this.deleteFileModal().onDelete();
            } else {
                this.deleteFile();
            }
        }
    }

    protected onDeleteFileModalClosed(result: ConfirmModalResultEnum): void {
        if (result === ConfirmModalResultEnum.Confirm) {
            this.deleteFile();
        }
    }

    protected undoDeleteFile(): void {
        if (this.isDeleted() && this.allowUndoDelete()) {
            this.isDeleted.set(false);
            this.undoDelete.emit(this.attachment());
        }
    }

    private deleteFile(): void {
        this.isDeleted.set(true);
        this.delete.emit(this.attachment());
    }
}
